var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4262 3.40625C34.3964 3.40625 43.2895 12.2993 43.2895 23.2695C43.2895 34.2397 34.3964 43.1327 23.4262 43.1327C12.456 43.1327 3.56299 34.2397 3.56299 23.2695C3.56299 12.2993 12.456 3.40625 23.4262 3.40625ZM23.4262 5.8901C21.1439 5.8901 18.884 6.33963 16.7754 7.21303C14.6669 8.08643 12.751 9.36658 11.1371 10.9804C9.52332 12.5942 8.24316 14.5101 7.36977 16.6187C6.49637 18.7273 6.04684 20.9872 6.04684 23.2695C6.04684 25.5518 6.49637 27.8117 7.36977 29.9203C8.24316 32.0289 9.52332 33.9448 11.1371 35.5586C12.751 37.1724 14.6669 38.4526 16.7754 39.326C18.884 40.1994 21.1439 40.6489 23.4262 40.6489C28.0358 40.6489 32.4565 38.8178 35.716 35.5583C38.9754 32.2989 40.8066 27.8781 40.8066 23.2686C40.8066 18.659 38.9754 14.2382 35.716 10.9788C32.4565 7.71935 28.0358 5.8901 23.4262 5.8901Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3328 32.8687C17.2242 33.6576 15.7808 32.5434 16.2235 31.2664L18.3176 25.2148L13.575 21.6016C12.5176 20.7957 13.0775 19.0874 14.4112 19.0874H20.3286L22.103 13.3744C22.5097 12.0653 24.3447 12.0653 24.7514 13.3744L26.5259 19.0874H32.4432C33.7542 19.0874 34.3293 20.7484 33.3134 21.5751L28.8357 25.2148L30.6518 31.4008C31.0244 32.6701 29.5924 33.7125 28.5141 32.9331L23.4197 29.2499L18.3309 32.8687H18.3328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleStar);
export default __webpack_public_path__ + "static/media/singleStar.eb4b37cb4592d72ad1a48e115d1e50c2.svg";
export { ForwardRef as ReactComponent };